exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bottom-row.bottom-row.bottom-row.bottom-row[data-v-a1411282]{margin-left:-15px}.request-funds-approve-container[data-v-a1411282]{width:100%}.request-funds-validation[data-v-a1411282]{align-items:left;justify-content:flex-start}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a1411282","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/_modules/Dashboard/widgets/ApprovalNeeded/approve-dialog.vue
// module id = GNH0
// module chunks = 12